import { Component, OnDestroy } from '@angular/core';

let active_close: (() => void) | null = null;

@Component({
  selector: 'app-list-action-buttons',
  imports: [],
  templateUrl: './list-action-buttons.component.html',
  styles: [`:host { display: flex; align-items: center; justify-content: center; height: 100%; }`]
})
export class ListActionButtonsComponent implements OnDestroy {
  params: any;
  buttons: any[] = [];
  inline = false;
  is_open = false;
  is_active = true;
  private dropdown_el: HTMLElement | null = null;
  private doc_listener: ((e: MouseEvent) => void) | null = null;

  agInit(params: any): void {
    this.params = params;
    this.inline = !!params.inline;
    this.buttons = this.params.actions(params.data);
    this.is_active = params.data?.is_active !== false;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.inline = !!params.inline;
    this.buttons = this.params.actions(params.data);
    this.is_active = params.data?.is_active !== false;
    return true;
  }

  async perform_action(button: any, event: any) {
    if (button.disabled) return;
    try {
      await button.function(this.params.data, this.params.node?.rowIndex, this.params, button, event);
      this.params.api?.refreshCells({ rowNodes: [this.params.node], force: true });
    } catch (err) {
      console.error('Action error:', err);
    }
  }

  toggle_dropdown(event: MouseEvent) {
    event.stopPropagation();
    const already_open = !!this.dropdown_el;
    if (active_close) active_close();
    if (already_open) return;
    const btn = event.currentTarget as HTMLElement;
    const rect = btn.getBoundingClientRect();
    this.open(rect.bottom + 4, rect.right - 180);
  }

  private order_weight(text: string): number {
    const t = (text || '').toLowerCase();
    if (t === 'view') return 0;
    if (t === 'update' || t === 'edit') return 1;
    if (t === 'disable' || t === 'enable') return 2;
    if (t === 'delete') return 3;
    return 4;
  }

  private open(top: number, left: number) {
    const visible = this.buttons
      .filter(b => b.permissions === undefined || b.permissions)
      .sort((a, b) => this.order_weight(a.text) - this.order_weight(b.text));
    if (!visible.length) return;

    const wrapper = document.createElement('div');
    wrapper.style.cssText = `position:fixed;top:${top}px;left:${left}px;z-index:9999;background:#E8E8F9;border-radius:6px;box-shadow:0 8px 32px rgba(0,0,0,0.15);min-width:180px;padding:8px 0;overflow:hidden;`;

    visible.forEach(button => {
      const row = document.createElement('div');
      const is_delete = (button.text || '').toLowerCase() === 'delete';

      if (!button.function) {
        row.style.cssText = `display:flex;align-items:center;gap:12px;padding:10px 20px;color:#9CA3AF;font-style:italic;font-size:14px;cursor:default;`;
        row.textContent = button.text;
        wrapper.appendChild(row);
        return;
      }

      row.style.cssText = `display:flex;align-items:center;gap:12px;padding:10px 20px;cursor:${button.disabled ? 'not-allowed' : 'pointer'};opacity:${button.disabled ? '0.4' : '1'};color:${is_delete ? '#FA2912' : '#212121'};transition:background 0.15s;`;
      row.addEventListener('mouseenter', () => { if (!button.disabled) row.style.background = '#D4D4F0'; });
      row.addEventListener('mouseleave', () => { row.style.background = ''; });

      const icon_src = this.get_icon_src(button.text);
      if (icon_src) {
        const img = document.createElement('img');
        img.src = icon_src;
        img.style.cssText = 'width:24px;height:24px;flex-shrink:0;';
        row.appendChild(img);
      } else if (button.icon) {
        const i = document.createElement('i');
        i.className = button.icon + ' text-xl';
        i.style.flexShrink = '0';
        row.appendChild(i);
      }

      const label = document.createElement('span');
      const t = (button.text || '').toLowerCase();
      label.textContent = button.text;
      label.style.cssText = 'font-size:15px;font-weight:500;';
      row.appendChild(label);

      row.addEventListener('click', async (e) => {
        e.stopPropagation();
        if (button.disabled) return;
        this.close();
        try {
          await button.function(this.params.data, this.params.node?.rowIndex, this.params, button, e);
          this.params.api?.refreshCells({ rowNodes: [this.params.node], force: true });
        } catch (err) {
          console.error('Action error:', err);
        }
      });

      wrapper.appendChild(row);
    });

    document.body.appendChild(wrapper);
    this.dropdown_el = wrapper;
    this.is_open = true;
    active_close = () => this.close();
    this.doc_listener = (e: MouseEvent) => {
      if (!wrapper.contains(e.target as Node)) this.close();
    };
    setTimeout(() => document.addEventListener('click', this.doc_listener!), 0);
  }

  private close() {
    if (this.dropdown_el) { this.dropdown_el.remove(); this.dropdown_el = null; }
    if (this.doc_listener) { document.removeEventListener('click', this.doc_listener); this.doc_listener = null; }
    this.is_open = false;
    active_close = null;
  }

  ngOnDestroy() { this.close(); }

  private get_icon_src(text: string): string {
    const t = (text || '').toLowerCase();
    if (t === 'view') return 'assets/action-view.png';
    if (t === 'update' || t === 'edit') return 'assets/action-edit.png';
    if (t === 'disable' || t === 'enable') return 'assets/action-disable.png';
    if (t === 'delete') return 'assets/trash.png';
    return '';
  }
}
